// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/fabric_template.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  CablingStrategy,
  cablingStrategyFromJSON,
  cablingStrategyToJSON,
  FabricTemplateType,
  fabricTemplateTypeFromJSON,
  fabricTemplateTypeToJSON,
} from "./fabric";

export const protobufPackage = "models";

export enum TemplateTagType {
  TEMPLATE_TAG_TYPE_UNDEFINED = 0,
  TEMPLATE_TAG_TYPE_DEVICE_MODEL_NAME = 1,
  TEMPLATE_TAG_TYPE_GPU_COUNT = 2,
  TEMPLATE_TAG_TYPE_FEATURE_FLAG = 3,
  TEMPLATE_TAG_TYPE_PORT_SPEED = 4,
  TEMPLATE_TAG_TYPE_TOPOLOGY_ARCH = 5,
  TEMPLATE_TAG_TYPE_PROPERTY = 6,
  TEMPLATE_TAG_TYPE_SWITCH_MODEL_NAME = 7,
  UNRECOGNIZED = -1,
}

export function templateTagTypeFromJSON(object: any): TemplateTagType {
  switch (object) {
    case 0:
    case "TEMPLATE_TAG_TYPE_UNDEFINED":
      return TemplateTagType.TEMPLATE_TAG_TYPE_UNDEFINED;
    case 1:
    case "TEMPLATE_TAG_TYPE_DEVICE_MODEL_NAME":
      return TemplateTagType.TEMPLATE_TAG_TYPE_DEVICE_MODEL_NAME;
    case 2:
    case "TEMPLATE_TAG_TYPE_GPU_COUNT":
      return TemplateTagType.TEMPLATE_TAG_TYPE_GPU_COUNT;
    case 3:
    case "TEMPLATE_TAG_TYPE_FEATURE_FLAG":
      return TemplateTagType.TEMPLATE_TAG_TYPE_FEATURE_FLAG;
    case 4:
    case "TEMPLATE_TAG_TYPE_PORT_SPEED":
      return TemplateTagType.TEMPLATE_TAG_TYPE_PORT_SPEED;
    case 5:
    case "TEMPLATE_TAG_TYPE_TOPOLOGY_ARCH":
      return TemplateTagType.TEMPLATE_TAG_TYPE_TOPOLOGY_ARCH;
    case 6:
    case "TEMPLATE_TAG_TYPE_PROPERTY":
      return TemplateTagType.TEMPLATE_TAG_TYPE_PROPERTY;
    case 7:
    case "TEMPLATE_TAG_TYPE_SWITCH_MODEL_NAME":
      return TemplateTagType.TEMPLATE_TAG_TYPE_SWITCH_MODEL_NAME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TemplateTagType.UNRECOGNIZED;
  }
}

export function templateTagTypeToJSON(object: TemplateTagType): string {
  switch (object) {
    case TemplateTagType.TEMPLATE_TAG_TYPE_UNDEFINED:
      return "TEMPLATE_TAG_TYPE_UNDEFINED";
    case TemplateTagType.TEMPLATE_TAG_TYPE_DEVICE_MODEL_NAME:
      return "TEMPLATE_TAG_TYPE_DEVICE_MODEL_NAME";
    case TemplateTagType.TEMPLATE_TAG_TYPE_GPU_COUNT:
      return "TEMPLATE_TAG_TYPE_GPU_COUNT";
    case TemplateTagType.TEMPLATE_TAG_TYPE_FEATURE_FLAG:
      return "TEMPLATE_TAG_TYPE_FEATURE_FLAG";
    case TemplateTagType.TEMPLATE_TAG_TYPE_PORT_SPEED:
      return "TEMPLATE_TAG_TYPE_PORT_SPEED";
    case TemplateTagType.TEMPLATE_TAG_TYPE_TOPOLOGY_ARCH:
      return "TEMPLATE_TAG_TYPE_TOPOLOGY_ARCH";
    case TemplateTagType.TEMPLATE_TAG_TYPE_PROPERTY:
      return "TEMPLATE_TAG_TYPE_PROPERTY";
    case TemplateTagType.TEMPLATE_TAG_TYPE_SWITCH_MODEL_NAME:
      return "TEMPLATE_TAG_TYPE_SWITCH_MODEL_NAME";
    case TemplateTagType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface FabricTemplateEntityMetadata {
  /** model name of the entity in the blueprint */
  modelName: string;
  /** The number of such entities in the blueprint */
  quantity: number;
  /** The group name for the entity */
  groupName: string;
  /** The tier name for the entity */
  tierName: string;
  /** The short name for the group */
  groupShortName: string;
  /** The short name for the tier */
  tierShortName: string;
}

export interface FabricTemplateInventory {
  entities: FabricTemplateEntityMetadata[];
}

export interface FabricTemplateConnectivityMetadata {
  /** switch or server group in the connectivity metadata */
  group1Name: string;
  /** switch or server group in the connectivity metadata */
  group2Name: string;
  /** group1 breakout (specifies if group1 is the North end of the breakout) */
  group1Breakout: boolean;
  /** group2 breakout (specifies if group2 is the North end of the breakout) */
  group2Breakout: boolean;
  /** num direct connections */
  numConns: number;
  /** cable type for connection */
  cableType: string;
  /** pluggable for group1 */
  group1Pluggable: string;
  /** server port group type for server<->switch group connections */
  portType: string;
  /** rail group name for server E/W <->switch group connections */
  railGroupName: string;
  /** pluggable for group2 */
  group2Pluggable: string;
  /** ipm probe type */
  probeType: string;
  /** cable Pid for connection */
  cablePid: string;
  /** port set id for the port in case of server breakouts especially for C880 E/W ports. 0 means there is no breakout. */
  portSetId: number;
  /** cabling strategy for the connection */
  cablingStrategy: CablingStrategy;
  /** Server_tray_model_name denotes the tray model name to utilize for the connection, if it is a rack server */
  serverTrayModelName: string;
  /** Tor tray ids denotes the tor switch tray ids to use for the connection in case of a rack */
  torTrayIds: number[];
}

export interface FabricTemplateManualOverrideMetadata {
  /** switch or server group in the connectivity metadata */
  group1Name: string;
  /** hardware set position in group1 */
  hs1Position: number;
  /** node position in the hardware set 1 */
  node1Position: number;
  /** port1 name */
  port1Name: string;
  /** cable type for connection */
  cableType: string;
  /** pluggable for group1 */
  group1Pluggable: string;
  /** pluggable for group2 */
  group2Pluggable: string;
  /** switch or server group in the connectivity metadata */
  group2Name: string;
  /** hardware set position in group2 */
  hs2Position: number;
  /** node position in the hardware set 2 */
  node2Position: number;
  /** port2 name */
  port2Name: string;
}

export interface FabricTemplateConnections {
  connections: FabricTemplateConnectivityMetadata[];
}

export interface FabricTemplateConnectionOverrides {
  overrides: FabricTemplateManualOverrideMetadata[];
}

export interface FabricTemplateTag {
  tagType: TemplateTagType;
  deviceModelNames: string[];
  gpuCount: number;
  featureFlags: string[];
  portSpeeds: string[];
  topologyArch: string;
  properties: string[];
  switchModelNames: string[];
}

/**
 * Fabric blueprint template has all the metadata for a
 * fabric blueprint template
 */
export interface FabricBlueprintTemplate {
  /** The name of the blueprint template */
  name: string;
  /** The id of the template */
  templateId: string;
  /** The summary/description of the template */
  description: string;
  /** The type of the template (switch fabric, AI cluster, customer fabric) */
  type: FabricTemplateType;
  /** The summary of template inventory */
  inventory:
    | FabricTemplateInventory
    | undefined;
  /** The summary of template connectivity */
  connections:
    | FabricTemplateConnections
    | undefined;
  /** The summary of template connectivity overrides */
  overrides: FabricTemplateConnectionOverrides | undefined;
  fabricTemplateTags: FabricTemplateTag[];
}

export interface FabricTemplateFilters {
  gpuCounts: number[];
  deviceModelNames: string[];
  portSpeeds: string[];
  topologies: string[];
  properties: string[];
  switchModelNames: string[];
}

function createBaseFabricTemplateEntityMetadata(): FabricTemplateEntityMetadata {
  return { modelName: "", quantity: 0, groupName: "", tierName: "", groupShortName: "", tierShortName: "" };
}

export const FabricTemplateEntityMetadata: MessageFns<FabricTemplateEntityMetadata> = {
  encode(message: FabricTemplateEntityMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(10).string(message.modelName);
    }
    if (message.quantity !== 0) {
      writer.uint32(16).uint32(message.quantity);
    }
    if (message.groupName !== "") {
      writer.uint32(26).string(message.groupName);
    }
    if (message.tierName !== "") {
      writer.uint32(34).string(message.tierName);
    }
    if (message.groupShortName !== "") {
      writer.uint32(42).string(message.groupShortName);
    }
    if (message.tierShortName !== "") {
      writer.uint32(50).string(message.tierShortName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateEntityMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateEntityMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.quantity = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tierName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.groupShortName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tierShortName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateEntityMetadata {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      tierName: isSet(object.tierName) ? globalThis.String(object.tierName) : "",
      groupShortName: isSet(object.groupShortName) ? globalThis.String(object.groupShortName) : "",
      tierShortName: isSet(object.tierShortName) ? globalThis.String(object.tierShortName) : "",
    };
  },

  toJSON(message: FabricTemplateEntityMetadata): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    if (message.tierName !== "") {
      obj.tierName = message.tierName;
    }
    if (message.groupShortName !== "") {
      obj.groupShortName = message.groupShortName;
    }
    if (message.tierShortName !== "") {
      obj.tierShortName = message.tierShortName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateEntityMetadata>, I>>(base?: I): FabricTemplateEntityMetadata {
    return FabricTemplateEntityMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateEntityMetadata>, I>>(object: I): FabricTemplateEntityMetadata {
    const message = createBaseFabricTemplateEntityMetadata();
    message.modelName = object.modelName ?? "";
    message.quantity = object.quantity ?? 0;
    message.groupName = object.groupName ?? "";
    message.tierName = object.tierName ?? "";
    message.groupShortName = object.groupShortName ?? "";
    message.tierShortName = object.tierShortName ?? "";
    return message;
  },
};

function createBaseFabricTemplateInventory(): FabricTemplateInventory {
  return { entities: [] };
}

export const FabricTemplateInventory: MessageFns<FabricTemplateInventory> = {
  encode(message: FabricTemplateInventory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      FabricTemplateEntityMetadata.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateInventory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateInventory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(FabricTemplateEntityMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateInventory {
    return {
      entities: globalThis.Array.isArray(object?.entities)
        ? object.entities.map((e: any) => FabricTemplateEntityMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricTemplateInventory): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => FabricTemplateEntityMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateInventory>, I>>(base?: I): FabricTemplateInventory {
    return FabricTemplateInventory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateInventory>, I>>(object: I): FabricTemplateInventory {
    const message = createBaseFabricTemplateInventory();
    message.entities = object.entities?.map((e) => FabricTemplateEntityMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricTemplateConnectivityMetadata(): FabricTemplateConnectivityMetadata {
  return {
    group1Name: "",
    group2Name: "",
    group1Breakout: false,
    group2Breakout: false,
    numConns: 0,
    cableType: "",
    group1Pluggable: "",
    portType: "",
    railGroupName: "",
    group2Pluggable: "",
    probeType: "",
    cablePid: "",
    portSetId: 0,
    cablingStrategy: 0,
    serverTrayModelName: "",
    torTrayIds: [],
  };
}

export const FabricTemplateConnectivityMetadata: MessageFns<FabricTemplateConnectivityMetadata> = {
  encode(message: FabricTemplateConnectivityMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.group1Name !== "") {
      writer.uint32(10).string(message.group1Name);
    }
    if (message.group2Name !== "") {
      writer.uint32(18).string(message.group2Name);
    }
    if (message.group1Breakout !== false) {
      writer.uint32(24).bool(message.group1Breakout);
    }
    if (message.group2Breakout !== false) {
      writer.uint32(32).bool(message.group2Breakout);
    }
    if (message.numConns !== 0) {
      writer.uint32(40).uint32(message.numConns);
    }
    if (message.cableType !== "") {
      writer.uint32(50).string(message.cableType);
    }
    if (message.group1Pluggable !== "") {
      writer.uint32(58).string(message.group1Pluggable);
    }
    if (message.portType !== "") {
      writer.uint32(66).string(message.portType);
    }
    if (message.railGroupName !== "") {
      writer.uint32(74).string(message.railGroupName);
    }
    if (message.group2Pluggable !== "") {
      writer.uint32(82).string(message.group2Pluggable);
    }
    if (message.probeType !== "") {
      writer.uint32(90).string(message.probeType);
    }
    if (message.cablePid !== "") {
      writer.uint32(98).string(message.cablePid);
    }
    if (message.portSetId !== 0) {
      writer.uint32(104).uint32(message.portSetId);
    }
    if (message.cablingStrategy !== 0) {
      writer.uint32(112).int32(message.cablingStrategy);
    }
    if (message.serverTrayModelName !== "") {
      writer.uint32(122).string(message.serverTrayModelName);
    }
    writer.uint32(130).fork();
    for (const v of message.torTrayIds) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateConnectivityMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateConnectivityMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.group1Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.group2Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.group1Breakout = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.group2Breakout = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.numConns = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cableType = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.group1Pluggable = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.portType = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.railGroupName = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.group2Pluggable = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.probeType = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.cablePid = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.portSetId = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.cablingStrategy = reader.int32() as any;
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.serverTrayModelName = reader.string();
          continue;
        }
        case 16: {
          if (tag === 128) {
            message.torTrayIds.push(reader.uint32());

            continue;
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.torTrayIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateConnectivityMetadata {
    return {
      group1Name: isSet(object.group1Name) ? globalThis.String(object.group1Name) : "",
      group2Name: isSet(object.group2Name) ? globalThis.String(object.group2Name) : "",
      group1Breakout: isSet(object.group1Breakout) ? globalThis.Boolean(object.group1Breakout) : false,
      group2Breakout: isSet(object.group2Breakout) ? globalThis.Boolean(object.group2Breakout) : false,
      numConns: isSet(object.numConns) ? globalThis.Number(object.numConns) : 0,
      cableType: isSet(object.cableType) ? globalThis.String(object.cableType) : "",
      group1Pluggable: isSet(object.group1Pluggable) ? globalThis.String(object.group1Pluggable) : "",
      portType: isSet(object.portType) ? globalThis.String(object.portType) : "",
      railGroupName: isSet(object.railGroupName) ? globalThis.String(object.railGroupName) : "",
      group2Pluggable: isSet(object.group2Pluggable) ? globalThis.String(object.group2Pluggable) : "",
      probeType: isSet(object.probeType) ? globalThis.String(object.probeType) : "",
      cablePid: isSet(object.cablePid) ? globalThis.String(object.cablePid) : "",
      portSetId: isSet(object.portSetId) ? globalThis.Number(object.portSetId) : 0,
      cablingStrategy: isSet(object.cablingStrategy) ? cablingStrategyFromJSON(object.cablingStrategy) : 0,
      serverTrayModelName: isSet(object.serverTrayModelName) ? globalThis.String(object.serverTrayModelName) : "",
      torTrayIds: globalThis.Array.isArray(object?.torTrayIds)
        ? object.torTrayIds.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: FabricTemplateConnectivityMetadata): unknown {
    const obj: any = {};
    if (message.group1Name !== "") {
      obj.group1Name = message.group1Name;
    }
    if (message.group2Name !== "") {
      obj.group2Name = message.group2Name;
    }
    if (message.group1Breakout !== false) {
      obj.group1Breakout = message.group1Breakout;
    }
    if (message.group2Breakout !== false) {
      obj.group2Breakout = message.group2Breakout;
    }
    if (message.numConns !== 0) {
      obj.numConns = Math.round(message.numConns);
    }
    if (message.cableType !== "") {
      obj.cableType = message.cableType;
    }
    if (message.group1Pluggable !== "") {
      obj.group1Pluggable = message.group1Pluggable;
    }
    if (message.portType !== "") {
      obj.portType = message.portType;
    }
    if (message.railGroupName !== "") {
      obj.railGroupName = message.railGroupName;
    }
    if (message.group2Pluggable !== "") {
      obj.group2Pluggable = message.group2Pluggable;
    }
    if (message.probeType !== "") {
      obj.probeType = message.probeType;
    }
    if (message.cablePid !== "") {
      obj.cablePid = message.cablePid;
    }
    if (message.portSetId !== 0) {
      obj.portSetId = Math.round(message.portSetId);
    }
    if (message.cablingStrategy !== 0) {
      obj.cablingStrategy = cablingStrategyToJSON(message.cablingStrategy);
    }
    if (message.serverTrayModelName !== "") {
      obj.serverTrayModelName = message.serverTrayModelName;
    }
    if (message.torTrayIds?.length) {
      obj.torTrayIds = message.torTrayIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateConnectivityMetadata>, I>>(
    base?: I,
  ): FabricTemplateConnectivityMetadata {
    return FabricTemplateConnectivityMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateConnectivityMetadata>, I>>(
    object: I,
  ): FabricTemplateConnectivityMetadata {
    const message = createBaseFabricTemplateConnectivityMetadata();
    message.group1Name = object.group1Name ?? "";
    message.group2Name = object.group2Name ?? "";
    message.group1Breakout = object.group1Breakout ?? false;
    message.group2Breakout = object.group2Breakout ?? false;
    message.numConns = object.numConns ?? 0;
    message.cableType = object.cableType ?? "";
    message.group1Pluggable = object.group1Pluggable ?? "";
    message.portType = object.portType ?? "";
    message.railGroupName = object.railGroupName ?? "";
    message.group2Pluggable = object.group2Pluggable ?? "";
    message.probeType = object.probeType ?? "";
    message.cablePid = object.cablePid ?? "";
    message.portSetId = object.portSetId ?? 0;
    message.cablingStrategy = object.cablingStrategy ?? 0;
    message.serverTrayModelName = object.serverTrayModelName ?? "";
    message.torTrayIds = object.torTrayIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseFabricTemplateManualOverrideMetadata(): FabricTemplateManualOverrideMetadata {
  return {
    group1Name: "",
    hs1Position: 0,
    node1Position: 0,
    port1Name: "",
    cableType: "",
    group1Pluggable: "",
    group2Pluggable: "",
    group2Name: "",
    hs2Position: 0,
    node2Position: 0,
    port2Name: "",
  };
}

export const FabricTemplateManualOverrideMetadata: MessageFns<FabricTemplateManualOverrideMetadata> = {
  encode(message: FabricTemplateManualOverrideMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.group1Name !== "") {
      writer.uint32(10).string(message.group1Name);
    }
    if (message.hs1Position !== 0) {
      writer.uint32(16).uint32(message.hs1Position);
    }
    if (message.node1Position !== 0) {
      writer.uint32(24).uint32(message.node1Position);
    }
    if (message.port1Name !== "") {
      writer.uint32(34).string(message.port1Name);
    }
    if (message.cableType !== "") {
      writer.uint32(42).string(message.cableType);
    }
    if (message.group1Pluggable !== "") {
      writer.uint32(50).string(message.group1Pluggable);
    }
    if (message.group2Pluggable !== "") {
      writer.uint32(58).string(message.group2Pluggable);
    }
    if (message.group2Name !== "") {
      writer.uint32(66).string(message.group2Name);
    }
    if (message.hs2Position !== 0) {
      writer.uint32(72).uint32(message.hs2Position);
    }
    if (message.node2Position !== 0) {
      writer.uint32(80).uint32(message.node2Position);
    }
    if (message.port2Name !== "") {
      writer.uint32(90).string(message.port2Name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateManualOverrideMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateManualOverrideMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.group1Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hs1Position = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.node1Position = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.port1Name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cableType = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.group1Pluggable = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.group2Pluggable = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.group2Name = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.hs2Position = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.node2Position = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.port2Name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateManualOverrideMetadata {
    return {
      group1Name: isSet(object.group1Name) ? globalThis.String(object.group1Name) : "",
      hs1Position: isSet(object.hs1Position) ? globalThis.Number(object.hs1Position) : 0,
      node1Position: isSet(object.node1Position) ? globalThis.Number(object.node1Position) : 0,
      port1Name: isSet(object.port1Name) ? globalThis.String(object.port1Name) : "",
      cableType: isSet(object.cableType) ? globalThis.String(object.cableType) : "",
      group1Pluggable: isSet(object.group1Pluggable) ? globalThis.String(object.group1Pluggable) : "",
      group2Pluggable: isSet(object.group2Pluggable) ? globalThis.String(object.group2Pluggable) : "",
      group2Name: isSet(object.group2Name) ? globalThis.String(object.group2Name) : "",
      hs2Position: isSet(object.hs2Position) ? globalThis.Number(object.hs2Position) : 0,
      node2Position: isSet(object.node2Position) ? globalThis.Number(object.node2Position) : 0,
      port2Name: isSet(object.port2Name) ? globalThis.String(object.port2Name) : "",
    };
  },

  toJSON(message: FabricTemplateManualOverrideMetadata): unknown {
    const obj: any = {};
    if (message.group1Name !== "") {
      obj.group1Name = message.group1Name;
    }
    if (message.hs1Position !== 0) {
      obj.hs1Position = Math.round(message.hs1Position);
    }
    if (message.node1Position !== 0) {
      obj.node1Position = Math.round(message.node1Position);
    }
    if (message.port1Name !== "") {
      obj.port1Name = message.port1Name;
    }
    if (message.cableType !== "") {
      obj.cableType = message.cableType;
    }
    if (message.group1Pluggable !== "") {
      obj.group1Pluggable = message.group1Pluggable;
    }
    if (message.group2Pluggable !== "") {
      obj.group2Pluggable = message.group2Pluggable;
    }
    if (message.group2Name !== "") {
      obj.group2Name = message.group2Name;
    }
    if (message.hs2Position !== 0) {
      obj.hs2Position = Math.round(message.hs2Position);
    }
    if (message.node2Position !== 0) {
      obj.node2Position = Math.round(message.node2Position);
    }
    if (message.port2Name !== "") {
      obj.port2Name = message.port2Name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateManualOverrideMetadata>, I>>(
    base?: I,
  ): FabricTemplateManualOverrideMetadata {
    return FabricTemplateManualOverrideMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateManualOverrideMetadata>, I>>(
    object: I,
  ): FabricTemplateManualOverrideMetadata {
    const message = createBaseFabricTemplateManualOverrideMetadata();
    message.group1Name = object.group1Name ?? "";
    message.hs1Position = object.hs1Position ?? 0;
    message.node1Position = object.node1Position ?? 0;
    message.port1Name = object.port1Name ?? "";
    message.cableType = object.cableType ?? "";
    message.group1Pluggable = object.group1Pluggable ?? "";
    message.group2Pluggable = object.group2Pluggable ?? "";
    message.group2Name = object.group2Name ?? "";
    message.hs2Position = object.hs2Position ?? 0;
    message.node2Position = object.node2Position ?? 0;
    message.port2Name = object.port2Name ?? "";
    return message;
  },
};

function createBaseFabricTemplateConnections(): FabricTemplateConnections {
  return { connections: [] };
}

export const FabricTemplateConnections: MessageFns<FabricTemplateConnections> = {
  encode(message: FabricTemplateConnections, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      FabricTemplateConnectivityMetadata.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateConnections {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateConnections();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.connections.push(FabricTemplateConnectivityMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateConnections {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => FabricTemplateConnectivityMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricTemplateConnections): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => FabricTemplateConnectivityMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateConnections>, I>>(base?: I): FabricTemplateConnections {
    return FabricTemplateConnections.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateConnections>, I>>(object: I): FabricTemplateConnections {
    const message = createBaseFabricTemplateConnections();
    message.connections = object.connections?.map((e) => FabricTemplateConnectivityMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricTemplateConnectionOverrides(): FabricTemplateConnectionOverrides {
  return { overrides: [] };
}

export const FabricTemplateConnectionOverrides: MessageFns<FabricTemplateConnectionOverrides> = {
  encode(message: FabricTemplateConnectionOverrides, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.overrides) {
      FabricTemplateManualOverrideMetadata.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateConnectionOverrides {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateConnectionOverrides();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.overrides.push(FabricTemplateManualOverrideMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateConnectionOverrides {
    return {
      overrides: globalThis.Array.isArray(object?.overrides)
        ? object.overrides.map((e: any) => FabricTemplateManualOverrideMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricTemplateConnectionOverrides): unknown {
    const obj: any = {};
    if (message.overrides?.length) {
      obj.overrides = message.overrides.map((e) => FabricTemplateManualOverrideMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateConnectionOverrides>, I>>(
    base?: I,
  ): FabricTemplateConnectionOverrides {
    return FabricTemplateConnectionOverrides.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateConnectionOverrides>, I>>(
    object: I,
  ): FabricTemplateConnectionOverrides {
    const message = createBaseFabricTemplateConnectionOverrides();
    message.overrides = object.overrides?.map((e) => FabricTemplateManualOverrideMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricTemplateTag(): FabricTemplateTag {
  return {
    tagType: 0,
    deviceModelNames: [],
    gpuCount: 0,
    featureFlags: [],
    portSpeeds: [],
    topologyArch: "",
    properties: [],
    switchModelNames: [],
  };
}

export const FabricTemplateTag: MessageFns<FabricTemplateTag> = {
  encode(message: FabricTemplateTag, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tagType !== 0) {
      writer.uint32(8).int32(message.tagType);
    }
    for (const v of message.deviceModelNames) {
      writer.uint32(18).string(v!);
    }
    if (message.gpuCount !== 0) {
      writer.uint32(24).uint32(message.gpuCount);
    }
    for (const v of message.featureFlags) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.portSpeeds) {
      writer.uint32(42).string(v!);
    }
    if (message.topologyArch !== "") {
      writer.uint32(50).string(message.topologyArch);
    }
    for (const v of message.properties) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.switchModelNames) {
      writer.uint32(66).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateTag {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateTag();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tagType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceModelNames.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.gpuCount = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.featureFlags.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.portSpeeds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.topologyArch = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.properties.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.switchModelNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateTag {
    return {
      tagType: isSet(object.tagType) ? templateTagTypeFromJSON(object.tagType) : 0,
      deviceModelNames: globalThis.Array.isArray(object?.deviceModelNames)
        ? object.deviceModelNames.map((e: any) => globalThis.String(e))
        : [],
      gpuCount: isSet(object.gpuCount) ? globalThis.Number(object.gpuCount) : 0,
      featureFlags: globalThis.Array.isArray(object?.featureFlags)
        ? object.featureFlags.map((e: any) => globalThis.String(e))
        : [],
      portSpeeds: globalThis.Array.isArray(object?.portSpeeds)
        ? object.portSpeeds.map((e: any) => globalThis.String(e))
        : [],
      topologyArch: isSet(object.topologyArch) ? globalThis.String(object.topologyArch) : "",
      properties: globalThis.Array.isArray(object?.properties)
        ? object.properties.map((e: any) => globalThis.String(e))
        : [],
      switchModelNames: globalThis.Array.isArray(object?.switchModelNames)
        ? object.switchModelNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FabricTemplateTag): unknown {
    const obj: any = {};
    if (message.tagType !== 0) {
      obj.tagType = templateTagTypeToJSON(message.tagType);
    }
    if (message.deviceModelNames?.length) {
      obj.deviceModelNames = message.deviceModelNames;
    }
    if (message.gpuCount !== 0) {
      obj.gpuCount = Math.round(message.gpuCount);
    }
    if (message.featureFlags?.length) {
      obj.featureFlags = message.featureFlags;
    }
    if (message.portSpeeds?.length) {
      obj.portSpeeds = message.portSpeeds;
    }
    if (message.topologyArch !== "") {
      obj.topologyArch = message.topologyArch;
    }
    if (message.properties?.length) {
      obj.properties = message.properties;
    }
    if (message.switchModelNames?.length) {
      obj.switchModelNames = message.switchModelNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateTag>, I>>(base?: I): FabricTemplateTag {
    return FabricTemplateTag.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateTag>, I>>(object: I): FabricTemplateTag {
    const message = createBaseFabricTemplateTag();
    message.tagType = object.tagType ?? 0;
    message.deviceModelNames = object.deviceModelNames?.map((e) => e) || [];
    message.gpuCount = object.gpuCount ?? 0;
    message.featureFlags = object.featureFlags?.map((e) => e) || [];
    message.portSpeeds = object.portSpeeds?.map((e) => e) || [];
    message.topologyArch = object.topologyArch ?? "";
    message.properties = object.properties?.map((e) => e) || [];
    message.switchModelNames = object.switchModelNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseFabricBlueprintTemplate(): FabricBlueprintTemplate {
  return {
    name: "",
    templateId: "",
    description: "",
    type: 0,
    inventory: undefined,
    connections: undefined,
    overrides: undefined,
    fabricTemplateTags: [],
  };
}

export const FabricBlueprintTemplate: MessageFns<FabricBlueprintTemplate> = {
  encode(message: FabricBlueprintTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.templateId !== "") {
      writer.uint32(18).string(message.templateId);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.inventory !== undefined) {
      FabricTemplateInventory.encode(message.inventory, writer.uint32(42).fork()).join();
    }
    if (message.connections !== undefined) {
      FabricTemplateConnections.encode(message.connections, writer.uint32(50).fork()).join();
    }
    if (message.overrides !== undefined) {
      FabricTemplateConnectionOverrides.encode(message.overrides, writer.uint32(58).fork()).join();
    }
    for (const v of message.fabricTemplateTags) {
      FabricTemplateTag.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricBlueprintTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricBlueprintTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.inventory = FabricTemplateInventory.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.connections = FabricTemplateConnections.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.overrides = FabricTemplateConnectionOverrides.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.fabricTemplateTags.push(FabricTemplateTag.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricBlueprintTemplate {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      type: isSet(object.type) ? fabricTemplateTypeFromJSON(object.type) : 0,
      inventory: isSet(object.inventory) ? FabricTemplateInventory.fromJSON(object.inventory) : undefined,
      connections: isSet(object.connections) ? FabricTemplateConnections.fromJSON(object.connections) : undefined,
      overrides: isSet(object.overrides) ? FabricTemplateConnectionOverrides.fromJSON(object.overrides) : undefined,
      fabricTemplateTags: globalThis.Array.isArray(object?.fabricTemplateTags)
        ? object.fabricTemplateTags.map((e: any) => FabricTemplateTag.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricBlueprintTemplate): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.type !== 0) {
      obj.type = fabricTemplateTypeToJSON(message.type);
    }
    if (message.inventory !== undefined) {
      obj.inventory = FabricTemplateInventory.toJSON(message.inventory);
    }
    if (message.connections !== undefined) {
      obj.connections = FabricTemplateConnections.toJSON(message.connections);
    }
    if (message.overrides !== undefined) {
      obj.overrides = FabricTemplateConnectionOverrides.toJSON(message.overrides);
    }
    if (message.fabricTemplateTags?.length) {
      obj.fabricTemplateTags = message.fabricTemplateTags.map((e) => FabricTemplateTag.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricBlueprintTemplate>, I>>(base?: I): FabricBlueprintTemplate {
    return FabricBlueprintTemplate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricBlueprintTemplate>, I>>(object: I): FabricBlueprintTemplate {
    const message = createBaseFabricBlueprintTemplate();
    message.name = object.name ?? "";
    message.templateId = object.templateId ?? "";
    message.description = object.description ?? "";
    message.type = object.type ?? 0;
    message.inventory = (object.inventory !== undefined && object.inventory !== null)
      ? FabricTemplateInventory.fromPartial(object.inventory)
      : undefined;
    message.connections = (object.connections !== undefined && object.connections !== null)
      ? FabricTemplateConnections.fromPartial(object.connections)
      : undefined;
    message.overrides = (object.overrides !== undefined && object.overrides !== null)
      ? FabricTemplateConnectionOverrides.fromPartial(object.overrides)
      : undefined;
    message.fabricTemplateTags = object.fabricTemplateTags?.map((e) => FabricTemplateTag.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFabricTemplateFilters(): FabricTemplateFilters {
  return { gpuCounts: [], deviceModelNames: [], portSpeeds: [], topologies: [], properties: [], switchModelNames: [] };
}

export const FabricTemplateFilters: MessageFns<FabricTemplateFilters> = {
  encode(message: FabricTemplateFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.gpuCounts) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.deviceModelNames) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.portSpeeds) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.topologies) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.properties) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.switchModelNames) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricTemplateFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricTemplateFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.gpuCounts.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.gpuCounts.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceModelNames.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portSpeeds.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.topologies.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.properties.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchModelNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricTemplateFilters {
    return {
      gpuCounts: globalThis.Array.isArray(object?.gpuCounts)
        ? object.gpuCounts.map((e: any) => globalThis.Number(e))
        : [],
      deviceModelNames: globalThis.Array.isArray(object?.deviceModelNames)
        ? object.deviceModelNames.map((e: any) => globalThis.String(e))
        : [],
      portSpeeds: globalThis.Array.isArray(object?.portSpeeds)
        ? object.portSpeeds.map((e: any) => globalThis.String(e))
        : [],
      topologies: globalThis.Array.isArray(object?.topologies)
        ? object.topologies.map((e: any) => globalThis.String(e))
        : [],
      properties: globalThis.Array.isArray(object?.properties)
        ? object.properties.map((e: any) => globalThis.String(e))
        : [],
      switchModelNames: globalThis.Array.isArray(object?.switchModelNames)
        ? object.switchModelNames.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FabricTemplateFilters): unknown {
    const obj: any = {};
    if (message.gpuCounts?.length) {
      obj.gpuCounts = message.gpuCounts.map((e) => Math.round(e));
    }
    if (message.deviceModelNames?.length) {
      obj.deviceModelNames = message.deviceModelNames;
    }
    if (message.portSpeeds?.length) {
      obj.portSpeeds = message.portSpeeds;
    }
    if (message.topologies?.length) {
      obj.topologies = message.topologies;
    }
    if (message.properties?.length) {
      obj.properties = message.properties;
    }
    if (message.switchModelNames?.length) {
      obj.switchModelNames = message.switchModelNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricTemplateFilters>, I>>(base?: I): FabricTemplateFilters {
    return FabricTemplateFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricTemplateFilters>, I>>(object: I): FabricTemplateFilters {
    const message = createBaseFabricTemplateFilters();
    message.gpuCounts = object.gpuCounts?.map((e) => e) || [];
    message.deviceModelNames = object.deviceModelNames?.map((e) => e) || [];
    message.portSpeeds = object.portSpeeds?.map((e) => e) || [];
    message.topologies = object.topologies?.map((e) => e) || [];
    message.properties = object.properties?.map((e) => e) || [];
    message.switchModelNames = object.switchModelNames?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
